<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            @change="$emit('change', $event)"
            :multiple="multiple"
            :item-text="itemText"
            :dense="dense"
            :autoComplete="autoComplete"
        />
        <sys-register-resource @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelecResource',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        multiple: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        itemText: {
            type: String,
            default: 'name'
        },
        dense: {
            type: Boolean,
            default: false
        },
        ambienceId: {

        }
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

        ambienceId(){
            this.getItems();
        }

    },
    methods: {
        ...mapActions('resource', ['ActionFindResources']),
        
        async getItems() {

            this.loading = true;
            var payload = {
                find_columns: {
                    active: 1
                },
                column_order: 'name'
            };

            if(this.ambienceId){
                payload.filter_relations = [
                    {
                        name:   'ambiences',
                        key:    'ambiences.id', 
                        value:  this.ambienceId,
                    },
                    {
                        name:   'ambiences',
                        key:    'ambience_resources.active', 
                        value:  1,
                    },
                    {
                        name:   'ambiences',
                        key:    'ambience_resources.allow_external_allocation', 
                        value:  1,
                    }
                ]
            }

            await this.ActionFindResources(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

    newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
                this.$emit('new-item', item);
            }
        }
    },

    
    
}
</script>